import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/i18n";
import Simulation from "@/pages/Simulation";
import Admin from "@/pages/Admin";
import Facilitator from "@/pages/Facilitator";
import Poster from "@/pages/Poster";
import LessonsWall from "@/pages/LessonsWall";
import PolicyPathways from "@/pages/PolicyPathways";
import LegalPage from "@/pages/LegalPage";
import SiteFooter from "@/components/SiteFooter";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Simulation />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/facilitator" element={<Facilitator />} />
            <Route path="/poster" element={<Poster />} />
            <Route path="/lessons" element={<LessonsWall />} />
            <Route path="/voices" element={<PolicyPathways />} />
            <Route path="/pathways" element={<PolicyPathways />} />
            <Route path="/terms" element={<LegalPage doc="terms" />} />
            <Route path="/privacy" element={<LegalPage doc="privacy" />} />
          </Routes>
          <SiteFooter />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
